import React from 'react'
import { motion } from 'framer-motion'

const ExperienceSection = () => {
  const experiences = [
    {
      id: 1,
      title: 'Senior Software Engineer (Tech Lead)',
      company: 'Adventure Dhaka Ltd.',
      period: 'Oct. 2024 - Present',
      location: 'Banani, Dhaka',
      description: 'Contributed to Skyticket, Japan\'s largest OTA platform Adventure Inc. competing with Expedia and Booking.com',
      achievements: [
        'Managed a team of 4–6 developers across multiple projects, ensuring timely delivery and code quality through Agile practices',
        'Collaborated with the DevOps team to implement CI/CD pipelines reduced 20% of deployment time'
      ],
      tags: ['PHP', 'Laravel', 'React', 'Docker', 'CI/CD']
    },
    {
      id: 2,
      title: 'Senior Web Developer 2',
      company: 'Shafi Consultancy Ltd.',
      period: 'June 2017 - Sept. 2024',
      location: 'Sylhet, Bangladesh',
      description: 'Led a team of 8 developers in delivering clinical trial systems for major EU pharma clients',
      achievements: [
        'Migrated legacy systems to Laravel and introduced CI/CD using Docker & GitHub Actions',
        'Spearheaded automated testing adoption with Selenium, reducing bugs by 40%'
      ],
      tags: ['Laravel', 'React', 'Docker', 'Selenium', 'CI/CD']
    },
    {
      id: 3,
      title: 'Web Developer',
      company: 'Smarty Soft',
      period: 'June 2014 - May. 2017',
      location: 'Sylhet, Bangladesh',
      description: 'Developed and designed web applications from scratch',
      achievements: [
        'Analyzed requirements and architected scalable databases',
        'Led project coordination across development and delivery phases'
      ],
      tags: ['PHP', 'MySQL', 'jQuery', 'HTML/CSS']
    }
  ]

  return (
    <section id="experience" className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Professional Experience
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-purple-400 mx-auto rounded-full" />
          </motion.div>

          {/* Experience timeline */}
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-500 to-purple-500"></div>

            {experiences.map((exp, index) => (
              <motion.div
                key={exp.id}
                className="relative mb-12 pl-16"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                {/* Timeline dot */}
                <div className="absolute left-6 top-0 w-4 h-4 bg-blue-500 rounded-full border-4 border-gray-900 shadow-lg"></div>

                {/* Experience card */}
                <div className="glass-light rounded-2xl p-8 hover:bg-white/10 transition-all duration-300">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-2">{exp.title}</h3>
                      <h4 className="text-xl text-blue-400 font-medium mb-1">{exp.company}</h4>
                      <p className="text-gray-400 text-sm">{exp.location}</p>
                    </div>
                    <span className="bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full text-sm font-medium mt-2 md:mt-0">
                      {exp.period}
                    </span>
                  </div>

                  <p className="text-gray-300 mb-6">{exp.description}</p>

                  <div className="mb-6">
                    <h5 className="text-lg font-semibold text-white mb-3">Key Achievements</h5>
                    <ul className="space-y-2">
                      {exp.achievements.map((achievement, achIndex) => (
                        <motion.li
                          key={achIndex}
                          className="flex items-start gap-3"
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.4, delay: index * 0.2 + achIndex * 0.1 }}
                          viewport={{ once: true }}
                        >
                          <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                          <span className="text-gray-300">{achievement}</span>
                        </motion.li>
                      ))}
                    </ul>
                  </div>

                  {/* Tech tags */}
                  <div className="flex flex-wrap gap-2">
                    {exp.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className="bg-white/10 text-gray-300 px-3 py-1 rounded-full text-sm hover:bg-white/20 transition-colors"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ExperienceSection